import styled, { css } from 'styled-components';
import StyleGuide from 'src/style-guide';

export const Title = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.utils.pxToRem(20)}rem;
    margin: ${theme.utils.pxToRem(11)}rem 0 ${theme.utils.pxToRem(24)}rem;
  `}
  font-weight: 700;
  color: ${({ theme }) => theme.colors.darkNavy2};
`;

export const Modal = styled(StyleGuide.Modal)`
  width: 440px;
  padding: 0;
`;

export const CloseModalIcon = styled.div`
  position: absolute;
  cursor: pointer;

  ${({ theme }) => css`
    top: ${theme.utils.pxToRem(16)}rem;
    right: ${theme.utils.pxToRem(16)}rem;
    width: ${theme.utils.pxToRem(16)}rem;
    height: ${theme.utils.pxToRem(16)}rem;
  `}

  .hv-svg svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;

    path {
      fill: ${({ theme }) => theme.colors.defaultGray};
    }
  }
  &:hover {
    color: ${({ theme }) => theme.colors.darkGray};
  }
`;

export const IconContainer = styled.div`
  display: inline-block;

  svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
  }
`;

export const ButtonGroup = styled.div`
  ${({ theme }) => css`
    margin: ${theme.utils.pxToRem(28)}rem 0;
    height: ${theme.utils.pxToRem(34)}rem;
  `}
  position: relative;
`;

export const ContinueButton = styled.button`
  margin-bottom: 0;
  padding: 10px 12px;
  width: 168px;
  line-height: 12px;
  font-size: ${({ theme }) => theme.utils.pxToRem(15)}rem;
  letter-spacing: 1px;
  box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.04);
  background-color: ${({ theme }) => theme.colors.defaultActionBlue};
  border: 1px solid ${({ theme }) => theme.colors.defaultActionBlue};
  border-radius: 3px;
`;

export const Description = styled.div`
  padding: 0 10px;
  opacity: 0.7;
  font-size: ${({ theme }) => theme.utils.pxToRem(14)}rem;
  line-height: 18px;
`;

export const ModalContent = styled.div`
  text-align: center;
  padding: 30px 40px 0;
`;
